import { Component } from '@angular/core';
import { PgFormField, PgFormLayout } from '../../../models/form.model';
import { SingleFormComponent } from '../single-form-main';

@Component({
    selector: 'app-forms-visit-card-service',
    templateUrl: './forms-visit-card-service.component.html',
    styleUrls: ['./forms-visit-card-service.component.scss'],
    standalone: false
})
export class FormsVisitCardServiceComponent extends SingleFormComponent {

    resourceId = 'VisitCardService';

    formLayout = new PgFormLayout([
        new PgFormField({ label: 'auto', type: 'string', name: 'name', required: true }),
        new PgFormField({ label: 'auto', type: 'file', name: 'image', fileType: 'images' }),
        new PgFormField({ label: 'auto', type: 'html', name: 'description', locale: true }),
        new PgFormField({ label: 'auto', type: 'select', name: 'realm_id' }),
    ]);

    availableLanguages:Array<string> = null;

    protected async afterInitializeForm() {
        this.availableLanguages = this.localizationService.availableApplicationLanguages;

        this.formLayout.getFieldByName('realm_id').visible = false;
    }
}

